import HomePage from 'pages/home';
import LoginPage from 'pages/login';
import NotFound from 'pages/not-found';
import RegisterPage from 'pages/register';
import ForgotPasswordPage from 'pages/forgot-password';
import RequestAccessPage from 'pages/request-access';
import UserManagement from 'pages/user-manager';
import { RouteObject } from 'types/route';
import { SIGNUP_ENABLED } from 'constants/app-info';
import NewsManager from 'pages/news-manager';
import RevenueManager from 'pages/revenue-manager';
import DataImportPage from 'pages/data-import';
import DataIssuesPage from 'pages/data-issues';
import OnlineRewardPage from 'pages/online-reward';
import OnlineRewardItemsPage from 'pages/online-reward/items';
import OnlineRewardPolicyPage from 'pages/online-reward/policy';
import EquipmentQuotePage from 'pages/equipment-quote';
import EquipmentQuoteEditor from 'pages/equipment-quote/editor';
import AgencyFeePage from 'pages/agency-fee';
import AgencyFeePolicyPage from 'pages/agency-fee/policy';
import KcMilestonesPage from 'pages/kc-milestones';
import AnalyticsPage from 'pages/analytics';
import KcLookupPage from 'pages/kc-lookup';
import GalaListPage from 'pages/gala';
import GalaEventPage from 'pages/gala/event-page';
import SoundsManager from 'pages/sounds-manager';
import RequestIdolManager from 'pages/request-idol-manager';
import MenuManager from 'pages/menus-manager';
import AdsManager from 'pages/ads-manager';
import PickIdolManager from '../pages/pick-idol-manager';
import PolicyManager from '../pages/policy-manager';
import DomesticManager from '../pages/domestic-manager';
import AddUserDomesticManager from '../pages/add-user-domestic-manager';
import SettingManager from '../pages/setting-manager';
import GroupDomesticDetailManager from '../pages/group-domestic-detail-manager';
import VoteManager from '../pages/vote-manager';
import AddUserVoteManager from '../pages/add-user-vote-manager';
import UserJoinVoteManager from '../pages/user-join-vote-manager';
import AttendanceManager from 'pages/attendance-manager';
import PayslipsManager from 'pages/payslips-manager';
import OvertimeManager from 'pages/overtime-manager';
import ShiftManager from 'pages/shift-manager';
import StarDashboardPage from 'pages/star-dashboard';
import StarAccountsPage from 'pages/star-accounts';
import StarLedgerPage from 'pages/star-ledger';
import StarMissionsPage from 'pages/star-missions';
import StarKcPage from 'pages/star-kc';
import StarShopPage from 'pages/star-shop';
import StarPenaltiesPage from 'pages/star-penalties';
import StarConfigPage from 'pages/star-config';
import StarRecruitsPage from 'pages/star-recruits';
import StarDancePage from 'pages/star-dance';
import SupportInboxPage from 'pages/support-inbox';
import SupportManagePage from 'pages/support-manage';
import FeedManagerPage from 'pages/feed-manager';
import WatermarkManagerPage from 'pages/watermark-manager';
import AccessGroupsPage from 'pages/access-groups';
import AccessPermissionsPage from 'pages/access-permissions';
import StaffConfirmPage from 'pages/staff-confirm';
import StudioListPage from 'pages/studio';
import StudioMinePage from 'pages/studio/mine';
import StudioDetailPage from 'pages/studio/detail';
import SsoPage from 'pages/sso';
import {
  LeavePage,
  LiveShowPage,
  MediaLinksPage,
  NotificationsPage,
  PkPage,
  redirectTo,
} from 'pages/merged';
import DepartmentManager from 'pages/department-manager';

export const paths = {
  home: '/',
  login: '/login',
  notFound: '*',
  chat: 'chat',
  // Trang xác thực công khai (bọc PublicOnlyRoute). Giữ khớp PUBLIC_AUTH_PATHS trong constants/app-info.ts.
  register: '/register',
  forgotPassword: '/forgot-password',
  requestAccess: '/request-access',
  // Link cũ trong email/bookmark → chuyển sang /forgot-password.
  legacyForgotPassword: '/send-mail-forgot-password',
  accountManagement: '/users-management',
  news: '/news-management',
  revenue: '/revenue-management',
  // Nhập file TikTok theo ngày / theo tháng (docs/nhap-du-lieu/DAC-TA-2026-09-29.md)
  dataImport: '/data-import',
  // Vấn đề dữ liệu, chỉ xem (docs/nhap-du-lieu/DAC-TA-DOT-2-VAN-DE-DU-LIEU-2026-09-29.md)
  dataIssues: '/data-issues',
  // Thưởng Online (docs/thuong-online/02-dac-ta-bang-data-creator.md §7)
  onlineReward: '/online-reward',
  onlineRewardItems: '/online-reward/items',
  onlineRewardPolicy: '/online-reward/policy',
  // Báo giá thiết bị + hợp đồng hỗ trợ (docs/bao-gia-thiet-bi/01-dac-ta-2026-10-27.md)
  equipmentQuotes: '/equipment-quotes',
  equipmentQuoteEditor: '/equipment-quotes/:id',
  agencyFee: '/agency-fee',
  agencyFeePolicy: '/agency-fee/policy',
  // Chúc mừng Creator đạt mốc KC (docs/chuc-mung-moc-kc/DAC-TA-2026-10-01.md §6)
  kcMilestones: '/kc-milestones',
  // Phân tích Creator (docs/phan-tich-creator/01-dac-ta-2026-10-06.md §8)
  analytics: '/analytics',
  // Tra cứu KC theo danh sách ID / email Đại diện (docs/tra-cuu-kc/)
  kcLookup: '/kc-lookup',
  sounds: '/sounds-management',
  pk: '/pk-management',
  liveShow: '/live-management',
  groupShow: '/show-management',
  job: '/job-management',
  store: '/store-management',
  outstanding: '/outstanding-management',
  requestIdol: '/request-idol-management',
  settingCountry: '/setting-country',
  menus: '/menus-management',
  banners: 'banners-management',
  settingAds: '/setting-ads',
  pick: '/pick-idol',
  policy: 'policy-manager',
  notification: 'notification-management',
  domestic: 'domestic-management',
  addUserToDomestic: 'domestic-user',
  settings: 'setting-management',
  groupDetail: '/group/:id/management',
  vote: '/vote-management',
  addUserVote: '/add-user-vote',
  listUserJoinVote: '/votes/:id/list-user',
  gala: '/gala',
  galaEvent: '/gala/:id',
  attendance: '/attendance-management',
  payslips: '/payslips-management',
  overtime: '/overtime-management',
  shift: '/shift-management',
  leaveTypes: '/admin/attendance/leave-types',
  leaveRequests: '/admin/attendance/leave-requests',
  // Điểm Sao
  starDashboard: '/star/dashboard',
  starAccounts: '/star/accounts',
  starLedger: '/star/ledger',
  starMissions: '/star/missions',
  starKc: '/star/kc',
  starShop: '/star/shop',
  starPenalties: '/star/penalties',
  starConfig: '/star/config',
  starRecruits: '/star/recruits',
  starDance: '/star/dance',
  // Hộp thư hỗ trợ
  support: '/support',
  supportManage: '/support/manage',
  // Bảng tin nội bộ (docs/bang-tin/03-admin.md)
  feed: '/feed',
  // Watermark chống lộ: cài đặt, tra mã, soi ảnh (docs/watermark/README.md)
  watermark: '/watermark',
  // Studio (docs/studio-quan-ly/SPEC-TRIEN-KHAI-STUDIO.md §8.1)
  studios: '/studios',
  studioMine: '/studio',
  studioDetail: '/studio/:id',
  // Nhóm & quyền + Xác nhận nhân viên (docs/to-chuc-lai-nhom-quyen/00-ban-do-va-phuong-an-2026-09-29.md)
  accessGroups: '/access/groups',
  accessPermissions: '/access/permissions',
  staffConfirm: '/staff-confirm',
  // Mở từ app (tab Tôi → Trang quản trị), tự đăng nhập bằng mã một lần.
  sso: '/sso',
  // Bộ phận / phòng ban (hydiamond, API /departments)
  departments: '/admin/attendance/departments',
};

const mainRoutes: RouteObject[] = [
  { path: paths.notFound, component: NotFound },
  { path: paths.login, component: LoginPage, isPublish: true },
  { path: paths.sso, component: SsoPage, isOpen: true },
  // Đăng ký bật mặc định; REACT_APP_ENABLE_SIGNUP=false thì /register chuyển sang /request-access.
  {
    path: paths.register,
    component: SIGNUP_ENABLED ? RegisterPage : redirectTo(paths.requestAccess),
    isPublish: true,
  },
  { path: paths.forgotPassword, component: ForgotPasswordPage, isPublish: true },
  { path: paths.requestAccess, component: RequestAccessPage, isPublish: true },
  {
    path: paths.legacyForgotPassword,
    component: redirectTo(paths.forgotPassword),
    isPublish: true,
  },
  { path: paths.home, component: HomePage },
  { path: paths.accountManagement, component: UserManagement },
  { path: paths.news, component: NewsManager },
  { path: paths.revenue, component: RevenueManager },
  { path: paths.dataImport, component: DataImportPage },
  { path: paths.dataIssues, component: DataIssuesPage },
  { path: paths.onlineReward, component: OnlineRewardPage },
  { path: paths.onlineRewardItems, component: OnlineRewardItemsPage },
  { path: paths.onlineRewardPolicy, component: OnlineRewardPolicyPage },
  { path: paths.equipmentQuotes, component: EquipmentQuotePage },
  { path: paths.equipmentQuoteEditor, component: EquipmentQuoteEditor },
  { path: paths.agencyFee, component: AgencyFeePage },
  { path: paths.agencyFeePolicy, component: AgencyFeePolicyPage },
  { path: paths.kcMilestones, component: KcMilestonesPage },
  { path: paths.analytics, component: AnalyticsPage },
  { path: paths.kcLookup, component: KcLookupPage },
  { path: paths.sounds, component: SoundsManager },
  { path: paths.pk, component: PkPage },
  { path: paths.settingCountry, component: redirectTo('/pk-management?tab=countries') },
  { path: paths.requestIdol, component: RequestIdolManager },
  { path: paths.banners, component: MediaLinksPage },
  { path: paths.menus, component: MenuManager },
  { path: paths.settingAds, component: AdsManager },
  { path: paths.liveShow, component: LiveShowPage },
  { path: paths.groupShow, component: redirectTo('/live-management?tab=groups') },
  { path: paths.job, component: redirectTo('/notification-management?tab=group') },
  { path: paths.store, component: redirectTo('/banners-management?tab=store') },
  { path: paths.outstanding, component: redirectTo('/banners-management?tab=outstanding') },
  { path: paths.pick, component: PickIdolManager },
  { path: paths.policy, component: PolicyManager },
  { path: paths.notification, component: NotificationsPage },
  { path: paths.domestic, component: DomesticManager },
  { path: paths.addUserToDomestic, component: AddUserDomesticManager },
  { path: paths.settings, component: SettingManager },
  { path: paths.groupDetail, component: GroupDomesticDetailManager },
  { path: paths.vote, component: VoteManager },
  { path: paths.addUserVote, component: AddUserVoteManager },
  { path: paths.listUserJoinVote, component: UserJoinVoteManager },
  { path: paths.gala, component: GalaListPage },
  { path: paths.galaEvent, component: GalaEventPage },
  { path: paths.attendance, component: AttendanceManager },
  { path: paths.payslips, component: PayslipsManager },
  { path: paths.overtime, component: OvertimeManager },
  { path: paths.shift, component: ShiftManager },
  { path: paths.leaveTypes, component: redirectTo('/admin/attendance/leave-requests?tab=types') },
  { path: paths.leaveRequests, component: LeavePage },
  { path: paths.starDashboard, component: StarDashboardPage },
  { path: paths.starAccounts, component: StarAccountsPage },
  { path: paths.starLedger, component: StarLedgerPage },
  { path: paths.starMissions, component: StarMissionsPage },
  { path: paths.starKc, component: StarKcPage },
  { path: paths.starShop, component: StarShopPage },
  { path: paths.starPenalties, component: StarPenaltiesPage },
  { path: paths.starConfig, component: StarConfigPage },
  { path: paths.starRecruits, component: StarRecruitsPage },
  { path: paths.starDance, component: StarDancePage },
  { path: paths.support, component: SupportInboxPage },
  { path: paths.supportManage, component: SupportManagePage },
  { path: paths.feed, component: FeedManagerPage },
  { path: paths.watermark, component: WatermarkManagerPage },
  { path: paths.accessGroups, component: AccessGroupsPage },
  { path: paths.accessPermissions, component: AccessPermissionsPage },
  { path: paths.staffConfirm, component: StaffConfirmPage },
  { path: paths.studios, component: StudioListPage },
  { path: paths.studioMine, component: StudioMinePage },
  { path: paths.studioDetail, component: StudioDetailPage },
  { path: paths.departments, component: DepartmentManager },
];

export { mainRoutes };
